export default __webpack_public_path__ + "static/media/Specc-Logo-Ct.b0baed91.svg";